import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout } from '../../../actions/auth';
import { Link } from 'react-router-dom';

const BusinessView = () => {

    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>

                    <div className='serviceHeader'>
                        <div className='d-flex justify-content-between p-3'>
                            <h2 className='fw-400'>Business Settings</h2>
                        </div>
                    </div>

                    <section className='settingSection p-5'>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className='card rounded-3'>
                                        <h5 className="card-title p-3 mb-0">Account Setup</h5>
                                        <hr className='m-0 p-0' />
                                        <div className="card-body p-0">
                                            <div className='border-bottom'>
                                                <div className='p-3'>
                                                    <Link to='/business-settings/business-hours' className='text-decoration-none text-dark d-flex justify-content-between align-items-center'>
                                                        <div>
                                                            <h4 className='mb-2'>Business working hours</h4>
                                                            <p>Manage working hours of your business</p>
                                                        </div>
                                                        <div>
                                                            -
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='border-bottom'>
                                                    <div className='p-3'>
                                                        <Link to='/business-settings/service-intervals' className='text-decoration-none text-dark d-flex justify-content-between align-items-center'>
                                                            <div>
                                                                <h4 className='mb-2'>Business service intervals</h4>
                                                                <p>Manage service intervals of your business</p>
                                                            </div>
                                                            <div>
                                                                -
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='border-bottom'>
                                                    <div className='p-3'>
                                                        <Link to='/business-settings/business-info' className='text-decoration-none text-dark d-flex justify-content-between align-items-center'>
                                                            <div>
                                                                <h4 className='mb-2'>Business Information</h4>
                                                            </div>
                                                            <div>
                                                                -
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </Fragment>
    )
}

BusinessView.propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { logout })(BusinessView);
